// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics_heading{
    color: #0066CC;
    font-weight: 600;
    font-size: 1.125rem;
}

.analytics_subheading{
    color: #838FB4;
    font-weight: 400;
    font-size: .875rem;
}

.systemAnalytics_container .card{
    background-color: #ffffff;
    border: 1px solid rgba(163, 174, 208, 0.5);
    border-radius: 20px;
    padding: 10px;
}

.metric-card h6{
    color: #111111;
    font-size: 1rem;
    font-weight: 400;
    
}

.metric-card h3{
    color: #0066CC;
    font-size: 2rem;
    font-weight: 600;

}

.metric-card small{
    color: #838FB4;
    font-size: .875rem;
    font-weight: 400;

}

.show_date_btn{
    border: 1px solid #E4E4E4;
    border-radius: 6px;
    color: #838FB4;
    font-size: 14px;
    font-weight: 400;
    padding: 12px;
    height: 35px;
}

.filterBtn{
    height: 35px;
}

.analytics_divider{
    background: rgba(0, 102, 204, 0.20);
    height: 1px;
}

.applicableFilter_container{
    position: absolute;
    top: 3%;
    right: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Analytics/SystemAnalytics.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;AACf","sourcesContent":[".analytics_heading{\n    color: #0066CC;\n    font-weight: 600;\n    font-size: 1.125rem;\n}\n\n.analytics_subheading{\n    color: #838FB4;\n    font-weight: 400;\n    font-size: .875rem;\n}\n\n.systemAnalytics_container .card{\n    background-color: #ffffff;\n    border: 1px solid rgba(163, 174, 208, 0.5);\n    border-radius: 20px;\n    padding: 10px;\n}\n\n.metric-card h6{\n    color: #111111;\n    font-size: 1rem;\n    font-weight: 400;\n    \n}\n\n.metric-card h3{\n    color: #0066CC;\n    font-size: 2rem;\n    font-weight: 600;\n\n}\n\n.metric-card small{\n    color: #838FB4;\n    font-size: .875rem;\n    font-weight: 400;\n\n}\n\n.show_date_btn{\n    border: 1px solid #E4E4E4;\n    border-radius: 6px;\n    color: #838FB4;\n    font-size: 14px;\n    font-weight: 400;\n    padding: 12px;\n    height: 35px;\n}\n\n.filterBtn{\n    height: 35px;\n}\n\n.analytics_divider{\n    background: rgba(0, 102, 204, 0.20);\n    height: 1px;\n}\n\n.applicableFilter_container{\n    position: absolute;\n    top: 3%;\n    right: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
